import { Dialog, DialogContent, DialogTitle } from "./ui/dialog";
import { imgSrc, catName } from "../lib/api";
import { LikeButton } from "./LikeButton";

export const Lightbox = ({ photo, onClose }) => (
  <Dialog open={!!photo} onOpenChange={(o) => !o && onClose()}>
    <DialogContent data-testid="photo-lightbox" className="max-w-5xl border-white/10 bg-[#0A0A0F] p-0">
      {photo && (
        <div>
          <img src={imgSrc(photo.src)} alt={photo.title} className="max-h-[75vh] w-full rounded-t-lg object-contain bg-black" />
          <div className="flex flex-wrap items-center justify-between gap-4 p-5">
            <div>
              <p className="font-mono-tech text-[11px] uppercase tracking-[0.2em] text-cyan-300">{catName(photo.category)}</p>
              <DialogTitle className="font-display text-3xl font-black uppercase">{photo.title}</DialogTitle>
              <p className="text-sm text-slate-400">por {photo.user_name}</p>
            </div>
            <LikeButton key={photo.id} photo={photo} size="lg" />
          </div>
        </div>
      )}
    </DialogContent>
  </Dialog>
);
